import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import Table from 'react-bootstrap/Table';
import CommissionAccountsHeadRow from './components/CommissionAccountsHeadRow';
import CommissionAccountsTableRow from './components/CommissionAccountsTableRow';
import PopUpUpdateSystemAccountIbanScheme from 'components/PopUpScheme/PopUpUpdateSystemAccountIbanScheme';
import i18nContext from 'components/i18n-context';
import Loader from 'components/Loader';
import Button from 'uikit/Button/Button';
import { PopUp } from 'uikit/PopUp/PopUp';
import './CommissionAccountsTable.scss';

const popUpInitialData = {
  isShowPopUp: false,
  currentIban: '',
  title: '',
  inputLabel: '',
  inputPlaceholder: '',
  onCancel: () => {},
  onConfirm: () => {}
};

const CommissionAccountsTable = ({ commissionTransactionsStore }) => {
  const i18n = useContext(i18nContext);
  const location = useLocation();
  const [popUpData, setPopUpData] = useState(popUpInitialData);

  useEffect(() => {
    if (commissionTransactionsStore.isInitialized) {
      commissionTransactionsStore.resetCommissionTransactionStore();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (!commissionTransactionsStore.isInitialized) {
      commissionTransactionsStore.getCommissionAccounts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commissionTransactionsStore.isInitialized]);

  const resetPopUpData = () => {
    setPopUpData(popUpInitialData);
  };

  const handleUpdateCommissionAccountIban = async (commissionAccountNumber, commissionAccountIban) => {
    setPopUpData({
      isShowPopUp: true,
      currentIban: commissionAccountIban,
      title: i18n.getMessage('commissions.commissionAccounts.updateIbanModal.title'),
      inputLabel: i18n.getMessage('commissions.commissionAccounts.updateIbanModal.input.iban.label'),
      inputPlaceholder: i18n.getMessage('commissions.commissionAccounts.updateIbanModal.input.iban.placeholder'),
      onConfirm: async (data) => {
        await commissionTransactionsStore.updateCommissionAccountIban(commissionAccountNumber, data);
        resetPopUpData();
      },
      onCancel: resetPopUpData
    });
  };

  if (!commissionTransactionsStore.isInitialized) {
    return <Loader className={'application-loader'} />;
  }

  return (
    <div className={'commission-accounts-wrapper'}>
      <div className={'commission-accounts-actions-wrapper'}>
        <Button
          className={'commission-accounts-button'}
          size={'medium'}
          type={'primary'}
          onClick={commissionTransactionsStore.handleExportCommissionBalances}
          isDisabled={
            !commissionTransactionsStore.isInitialized || commissionTransactionsStore.isLoadingCommissionBalances
          }
        >
          {commissionTransactionsStore.isLoadingCommissionBalances ? (
            <Loader />
          ) : (
            i18n.getMessage('commissions.commissionAccounts.button.downloadCommissionBalances')
          )}
        </Button>
      </div>

      <Table responsive>
        <thead>
          <CommissionAccountsHeadRow />
        </thead>
        <tbody>
          {commissionTransactionsStore.commissionAccounts &&
            commissionTransactionsStore.commissionAccounts.length > 0 &&
            commissionTransactionsStore.commissionAccounts.map((commissionAccount, index) => (
              <CommissionAccountsTableRow
                key={index}
                type={'list'}
                isLoading={commissionTransactionsStore.isLoading}
                commissionAccountData={commissionAccount}
                handleOpenUpdateIbanModal={handleUpdateCommissionAccountIban}
              />
            ))}
        </tbody>
      </Table>

      <PopUp alignOnCenter show={popUpData.isShowPopUp}>
        <PopUpUpdateSystemAccountIbanScheme
          isLoading={commissionTransactionsStore.isLoading}
          currentIban={popUpData.currentIban}
          title={popUpData.title}
          inputLabel={popUpData.inputLabel}
          inputPlaceholder={popUpData.inputPlaceholder}
          onClose={popUpData.onCancel}
          onConfirm={popUpData.onConfirm}
        />
      </PopUp>
    </div>
  );
};

CommissionAccountsTable.propTypes = {
  commissionTransactionsStore: MobXPropTypes.observableObject
};

export default inject((stores) => ({
  commissionTransactionsStore: stores.commissionTransactionsStore
}))(observer(CommissionAccountsTable));
